module.exports = __webpack_public_path__ + "static/media/Resume-Manu_Hegde.904d86fb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Resume-Manu_Hegde.pdf
// module id = 190
// module chunks = 2